import React from 'react'

const Submit = () => {
  return (
    <button className='btn btn-dark' type='submit'>
      Generar
    </button>
  )
}

export default Submit
